import { useTheme } from '@mui/material';
import { SVGProps } from 'react';

export const InfoCircleIcon = ({
  stroke,
  ...props
}: SVGProps<SVGSVGElement>) => {
  const theme = useTheme();
  const strokeColor = stroke || theme.palette.action.active;

  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M17.25 10C17.25 14.0041 14.0041 17.25 10 17.25C5.99594 17.25 2.75 14.0041 2.75 10C2.75 5.99594 5.99594 2.75 10 2.75C14.0041 2.75 17.25 5.99594 17.25 10Z"
        stroke={strokeColor}
        strokeLinecap="round"
        strokeWidth={1.5}
      />
      <path
        d="M10 14V10"
        stroke={strokeColor}
        strokeLinecap="round"
        strokeWidth={1.5}
      />
      <circle cx="10" cy="7" r="1" fill={strokeColor} />
    </svg>
  );
};
